import React from "react";

import { SIDEBAR_BRAND_LOGO_SRC } from "@/constants/sidebarBrandLogo";
import { cn } from "@/lib/utils";
import { WORKSPACE_ACCOUNT_CARD_INNER_SIZE } from "@/views/Dashboard/Workspace/workspaceGraphConstants";

type Props = {
  className?: string;
  /** Outer face size in px (default = Workspace account diamond inner). */
  size?: number;
  /** Logo size inside the rotated face. */
  logoClassName?: string;
  /** Soft pulse used while TES is waiting. */
  pulse?: boolean;
  "aria-hidden"?: boolean;
};

/**
 * Workspace executing-account diamond: white rounded face + colored Tessera mark.
 * Same asset/style as the canvas account node — not the gradient/white-logo variant.
 */
export function StrategyRdCoachWorkspaceDiamond({
  className,
  size = WORKSPACE_ACCOUNT_CARD_INNER_SIZE,
  logoClassName = "size-12",
  pulse = false,
  "aria-hidden": ariaHidden,
}: Props) {
  return (
    <div
      data-strategy-rd-coach-workspace-diamond=""
      className={cn(
        "flex rotate-45 items-center justify-center overflow-hidden rounded-lg border border-solid bg-card text-card-foreground shadow-sm dark:bg-sidebar dark:text-sidebar-foreground",
        pulse && "animate-pulse",
        className
      )}
      style={{
        width: size,
        height: size,
        borderWidth: 1.5,
        borderStyle: "solid",
        borderColor: "#6b7280",
        ...(pulse
          ? { animation: "workspace-node-loading-pulse 1.4s ease-in-out infinite" }
          : null),
      }}
      aria-hidden={ariaHidden}
    >
      <img
        src={SIDEBAR_BRAND_LOGO_SRC}
        alt=""
        className={cn("-rotate-45 object-contain", logoClassName)}
        draggable={false}
      />
    </div>
  );
}
